import React, { useContext, useEffect, useState } from "react";
import { errorSchema, utils } from 'helper';
import { CommonInput, CommonModal, CommonTextarea, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { handleKeyDown, podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from '_services/accountsServices/zoneServices';
import { UserContext } from "context";
import { useParams } from "react-router-dom";

const LrToLrTdsDeductionModal = (props) => {

    let { id } = useParams();
    const { isOpen, closeModal, callBackSelectLrModal } = props;

    const formObj = {
        company_id: StorageService.getCompanyId(),
        // amount: isOpen?.amount,
        tds_percentage: isOpen?.tds_percentage?.value ? {} : { value: 1, label: '1%' },
    }

    const { masterData } = useContext(UserContext);
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.tdsDeductionInvoiceSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.tdsDeductionInvoiceSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            callBackSelectLrModal({ ...formValue, tds_percentage: formValue?.tds_percentage, billraise_id: id });
            closeModal();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen?.tds_percentage?.value) {
            setFormValue((s) => ({ ...s, tds_percentage: isOpen?.tds_percentage }))
        }
    }, [isOpen?.tds_percentage?.value])

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        // disabled: props?.isOpen?.view || loading,
        onSubmit: handleClick,
    }

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className="singleDiv">
                            <CustomSelect
                                options={masterData.tds_section_list?.map((item) => {
                                    return {
                                        label: item?.name,
                                        value: item?.id
                                    }
                                })}
                                label="TDS Deduction %"
                                placeholder="TDS Deduction %"
                                name="tds_percentage"
                                onSelect={(data) => handleOnChange("tds_percentage", data)}
                                value={formValue?.tds_percentage}
                                focus={!!formError['tds_percentage.label']}
                                error={formError['tds_percentage.label']}
                            />
                        </div>

                        {/* <div className="singleDiv">
                            <CommonInput
                                type="text"
                                label="Amount (₹)"
                                placeholder="Amount (₹)"
                                name="amount"
                                value={formValue.amount}
                                onChange={({ target: { name, value } }) => {
                                    handleOnChange(name, value);
                                }}
                                maxLength={12}
                                onKeyDown={handleKeyDown}
                                focus={!!formError?.amount}
                                error={formError.amount}
                            />
                        </div> */}
                    </div>
                </div>
            </CommonModal>
            <div className='offBack_drop'></div>
        </div>
    )
}

export default LrToLrTdsDeductionModal
